import type { CSSProperties } from 'react';

import { style } from './style';
import type { VSpacerProps } from './type';

const VSpacer = ({ direction = 'horizontal', size = 1 }: VSpacerProps) => {
  const customStyle = {
    '--v-spacer-size': `${size * 4}px`,
  } as CSSProperties;

  return <div className={style.vSpacer(direction)} style={customStyle}></div>;
};

export default VSpacer;
